import type { LoanStatus } from '@/types';

/**
 * Mirrors backend loan status validation rules.
 * Keep this in sync with backend/src/modules/loan/services/loan.service.ts.
 */
export const LOAN_STATUS_TRANSITIONS: Partial<Record<LoanStatus, LoanStatus[]>> = {
  APPLICATION: ['UNDER_REVIEW', 'CANCELLED'],
  UNDER_REVIEW: ['APPROVED', 'CANCELLED'],
  APPROVED: ['DISBURSED', 'CANCELLED'],
  DISBURSED: ['CURRENT'],
  CURRENT: ['DELINQUENT_30', 'PAID_OFF', 'RESTRUCTURED'],
  DELINQUENT_30: ['CURRENT', 'DELINQUENT_60', 'PAID_OFF', 'RESTRUCTURED'],
  DELINQUENT_60: ['CURRENT', 'DELINQUENT_90', 'PAID_OFF', 'RESTRUCTURED'],
  DELINQUENT_90: ['CURRENT', 'DEFAULT', 'PAID_OFF', 'RESTRUCTURED'],
  DEFAULT: ['RESTRUCTURED', 'PAID_OFF'],
  RESTRUCTURED: [],
  PAID_OFF: [],
  CANCELLED: [],
};
